import {
  FECHA_TRAMO_3,
  UMBRAL_AUTOMATICO_PCT,
  calcularPAI,
  obtenerCoeficienteC,
  calcularBase,
  calcularDeltaP,
} from './calculo.ts';
import { lunesPublicacion, isoDay as toISODay } from './fechas.ts';
import { esNifValido } from './nif.ts';
import { registrarMcp } from './mcp.ts';

// Compartir la calculadora. Vive fuera de Angular porque el botón de la
// cabecera está fuera del controller y el del resultado puede delegar aquí.
// Solo se comparte el enlace (no el cálculo): el objetivo es que quien lo
// use pueda recomendar la herramienta a otros transportistas.
(function () {
  'use strict';

  var SHARE = {
    title: 'Calculadora de indexación de combustible · RD-ley 9/2026',
    text: 'Calcula la revisión obligatoria del precio del transporte por subida del gasóleo (RD-ley 9/2026, Tramo 3). Gratuita.',
    url: 'https://calculadora.mensatrans.com/'
  };
  var SVG_NS = 'http://www.w3.org/2000/svg';

  function abrirEnlace(url) {
    var w = window.open(url, '_blank', 'noopener,noreferrer');
    if (!w) window.location.href = url;
  }

  function copiarTexto(texto) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(texto).catch(function () { return fallback(); });
    }
    return Promise.resolve(fallback());
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = texto;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* nada que hacer */ }
      document.body.removeChild(ta);
    }
  }

  function svgEl(name, attrs) {
    var el = document.createElementNS(SVG_NS, name);
    for (var k in attrs) {
      if (Object.prototype.hasOwnProperty.call(attrs, k)) el.setAttribute(k, attrs[k]);
    }
    return el;
  }

  function svgIcono(tipo) {
    var svg = svgEl('svg', {
      width: '16', height: '16', viewBox: '0 0 24 24',
      'aria-hidden': 'true'
    });
    if (tipo === 'wa') {
      svg.setAttribute('fill', 'currentColor');
      var p = svgEl('path', { d:
        'M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488 11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.683 5.522l-.999 3.648 3.805-.869zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z'
      });
      svg.appendChild(p);
    } else {
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      if (tipo === 'mail') {
        svg.appendChild(svgEl('path', { d: 'M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z' }));
        svg.appendChild(svgEl('polyline', { points: '22,6 12,13 2,6' }));
      } else if (tipo === 'copy') {
        svg.appendChild(svgEl('rect', { x: '9', y: '9', width: '13', height: '13', rx: '2', ry: '2' }));
        svg.appendChild(svgEl('path', { d: 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1' }));
      }
    }
    return svg;
  }

  function crearItem(act, etiqueta, claseEtiqueta) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('role', 'menuitem');
    btn.setAttribute('data-act', act);
    btn.appendChild(svgIcono(act));
    var span = document.createElement('span');
    if (claseEtiqueta) span.className = claseEtiqueta;
    span.textContent = etiqueta;
    btn.appendChild(span);
    return btn;
  }

  var popoverActual = null;
  var cerrarFnActual = null;

  function cerrarPopover() {
    if (popoverActual && popoverActual.parentNode) {
      popoverActual.parentNode.removeChild(popoverActual);
    }
    popoverActual = null;
    if (cerrarFnActual) {
      document.removeEventListener('click', cerrarFnActual, true);
      document.removeEventListener('keydown', cerrarFnActual, true);
      window.removeEventListener('resize', cerrarFnActual);
      window.removeEventListener('scroll', cerrarFnActual, true);
      cerrarFnActual = null;
    }
  }

  function mostrarPopover(triggerEl, payload) {
    cerrarPopover();
    if (!triggerEl) return;

    // El "Copiar" cambia de etiqueta y de cuerpo según haya cálculo o no:
    // sin payload de resultado se copia el enlace; con payload se copia el
    // concepto de la factura + el enlace, listo para pegar en email/chat.
    var esResultado = !!payload.concepto;
    var copiarLabel = esResultado ? 'Copiar concepto' : 'Copiar enlace';
    var copiarOk = esResultado ? '¡Concepto copiado!' : '¡Enlace copiado!';
    var textoCopiar = esResultado ? (payload.text + '\n\n' + payload.url) : payload.url;

    var pop = document.createElement('div');
    pop.className = 'share-popover';
    pop.setAttribute('role', 'menu');
    pop.appendChild(crearItem('wa', 'WhatsApp'));
    pop.appendChild(crearItem('mail', 'Email'));
    pop.appendChild(crearItem('copy', copiarLabel, 'share-popover-copy-label'));

    document.body.appendChild(pop);

    // Posicionado: bajo el botón, alineado a su borde derecho.
    var rect = triggerEl.getBoundingClientRect();
    var popRect = pop.getBoundingClientRect();
    var top = rect.bottom + window.scrollY + 6;
    var left = rect.right + window.scrollX - popRect.width;
    var maxLeft = window.scrollX + document.documentElement.clientWidth - popRect.width - 8;
    var minLeft = window.scrollX + 8;
    if (left > maxLeft) left = maxLeft;
    if (left < minLeft) left = minLeft;
    pop.style.top = top + 'px';
    pop.style.left = left + 'px';

    pop.addEventListener('click', function (ev) {
      var btn = ev.target.closest('button[data-act]');
      if (!btn) return;
      var act = btn.getAttribute('data-act');
      if (act === 'wa') {
        abrirEnlace('https://wa.me/?text=' + encodeURIComponent(payload.text + ' ' + payload.url));
        cerrarPopover();
      } else if (act === 'mail') {
        // mailto no se abre con window.open en algunos navegadores: navegar es la vía fiable.
        window.location.href = 'mailto:?subject=' + encodeURIComponent(payload.title) +
                               '&body=' + encodeURIComponent(payload.text + '\n\n' + payload.url);
        cerrarPopover();
      } else if (act === 'copy') {
        var label = btn.querySelector('.share-popover-copy-label');
        copiarTexto(textoCopiar).then(function () {
          if (label) label.textContent = copiarOk;
          setTimeout(cerrarPopover, 900);
        });
      }
    });

    cerrarFnActual = function (ev) {
      if (ev && ev.type === 'click' && pop.contains(ev.target)) return;
      if (ev && ev.type === 'click' && triggerEl.contains(ev.target)) return;
      if (ev && ev.type === 'keydown' && ev.key !== 'Escape') return;
      cerrarPopover();
    };
    // Pequeño defer para que el click que abrió el popover no lo cierre inmediatamente.
    setTimeout(function () {
      document.addEventListener('click', cerrarFnActual, true);
      document.addEventListener('keydown', cerrarFnActual, true);
      window.addEventListener('resize', cerrarFnActual);
      window.addEventListener('scroll', cerrarFnActual, true);
    }, 0);

    popoverActual = pop;
  }

  // payload opcional: si no se pasa, comparte la herramienta (cabecera).
  // Si se pasa { title, text, url, concepto: true } comparte el resultado.
  window.__calcCompartir = function (triggerEl, payload) {
    if (popoverActual) { cerrarPopover(); return; }
    var p = payload || SHARE;
    if (navigator.share) {
      navigator.share({ title: p.title, text: p.text, url: p.url })
        .catch(function (err) {
          // AbortError = el usuario canceló, no es un fallo.
          if (err && err.name === 'AbortError') return;
          mostrarPopover(triggerEl, p);
        });
    } else {
      mostrarPopover(triggerEl, p);
    }
  };
})();

(function () {
  'use strict';

  angular.module('indexacionApp', [])
    .controller('CalculadoraController', CalculadoraController);

  // Caché en cliente por semana (clave = lunes de publicación, ISO YYYY-MM-DD).
  // El MITMS publica un precio semanal; los datos pasados no cambian.
  var cacheSemanas = {};

  CalculadoraController.$inject = ['$http', '$timeout', '$q'];
  function CalculadoraController($http, $timeout, $q) {
    var vm = this;

    // Presets pensados para subcontratistas de mensajería (GLS, NACEX, TIPSA, CTT…).
    // 'urbano' es el caso mayoritario: furgoneta < 3,5 t sin derecho a IH-GP.
    var PRESETS = {
      urbano:   { categoria: 'ligero',  gasoleoProf: false },
      rigido:   { categoria: 'entre',   gasoleoProf: true  },
      tractora: { categoria: 'mayor20', gasoleoProf: true  }
    };

    // Caso habitual: el usuario factura el mes anterior. Las agencias revisan
    // tarifas el 1 de enero, así que la firma se ancla al inicio del "año
    // tarifa" al que pertenece la fecha de ejecución (importa en enero, donde
    // ejecución cae en diciembre del año previo).
    var ahora = new Date();
    vm.fechaEjecucion = new Date(ahora.getFullYear(), ahora.getMonth(), 0);
    vm.fechaFirma = new Date(vm.fechaEjecucion.getFullYear(), 0, 1);
    vm.precioFirma = null;
    vm.precioEjecucion = null;
    vm.tipoOperacion = 'urbano';
    vm.categoria = PRESETS.urbano.categoria;
    vm.gasoleoProf = PRESETS.urbano.gasoleoProf;

    vm.facturas = [{ ref: '', importe: null }];

    vm.calcularCosteKm = false;
    vm.consumoL100 = 35;
    vm.kilometros = 10000;
    vm.costeKmEmpresa = null;

    vm.esContinuado = true;
    vm.resultado = null;
    vm.faltaImporte = false;

    // Datos opcionales para enriquecer el PDF. La sección está oculta por
    // defecto y se despliega vía el checkbox "rellenar datos para el justificante".
    vm.rellenarJustificante = false;
    vm.emisor = { razonSocial: '', nif: '', direccion: '' };
    vm.cliente = { razonSocial: '', nif: '' };

    vm.errorPrecios = null;
    vm.avisoPrecios = null;
    vm.cargandoPrecios = false;

    cargarPerfil();

    vm.recalcular = recalcular;
    vm.aplicarPreset = aplicarPreset;
    vm.onEdicionManual = onEdicionManual;
    vm.onFechaCambio = onFechaCambio;
    vm.onFechaFirmaCambio = onFechaFirmaCambio;
    vm.onFechaEjecucionCambio = onFechaEjecucionCambio;
    vm.anadirFactura = anadirFactura;
    vm.eliminarFactura = eliminarFactura;
    vm.imprimir = imprimir;
    vm.copiarConcepto = copiarConcepto;
    vm.descargarCSV = descargarCSV;
    vm.enfocarImporte = function (ev) {
      // Lleva al usuario al primer importe vacío y lo enfoca, para que el
      // aviso "falta el importe" no sea sólo informativo sino accionable.
      if (ev) ev.preventDefault();
      var inputs = document.querySelectorAll('.facturas-edit input[type="number"]');
      var primerVacio = null;
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].value) { primerVacio = inputs[i]; break; }
      }
      var target = primerVacio || inputs[0];
      if (!target) return;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Pequeño delay para que el scroll-smooth no robe el foco al input.
      $timeout(function () { target.focus(); }, 250);
    };
    vm.compartir = function (ev) {
      var trigger = ev && ev.currentTarget;
      if (typeof window.__calcCompartir !== 'function') return;
      // Si hay resultado válido, mandamos también el cálculo para que se pueda
      // pegar en un email/WhatsApp al cliente. Si no, comparte sólo la herramienta.
      var payload = null;
      if (vm.resultado && !vm.resultado.error) {
        var r = vm.resultado;
        var partes = [
          'Indexación combustible RD-ley 9/2026',
          'Periodo ' + fmtFecha(vm.fechaFirma) + '–' + fmtFecha(vm.fechaEjecucion),
          'G = ' + (r.G > 0 ? '+' : '') + fmtNum(r.G, 2) + ' %',
          'C = ' + fmtNum(r.C, 1),
          'Ajuste ' + (r.deltaPTotal > 0 ? '+' : '') + fmtEur(r.deltaPTotal)
        ];
        payload = {
          title: 'Indexación combustible RD-ley 9/2026',
          text: partes.join(' · ') + '\nCálculo realizado con la calculadora gratuita',
          url: 'https://calculadora.mensatrans.com/',
          concepto: true
        };
      }
      window.__calcCompartir(trigger, payload);
    };
    vm.copiado = false;
    vm.generandoPdf = false;
    vm.onPerfilCambio = onPerfilCambio;
    vm.onEmisorCambio = guardarPerfil;
    vm.nifValido = esNifValido;
    vm.borrarPerfil = borrarPerfil;
    vm.pdfBloqueado = pdfBloqueado;
    vm.semanasUsadas = null;
    vm.fmtSemana = function (iso) { return fmtFecha(new Date(iso + 'T00:00:00')); };

    function pdfBloqueado() {
      // Si la sección de justificante está activa y un NIF rellenado no valida,
      // bloqueamos la descarga para no generar un documento con datos malos.
      if (!vm.rellenarJustificante) return false;
      if (vm.emisor.nif && !esNifValido(vm.emisor.nif)) return true;
      if (vm.cliente.nif && !esNifValido(vm.cliente.nif)) return true;
      return false;
    }

    var STORAGE_KEY = 'calc-combustible-perfil-v1';

    function cargarPerfil() {
      try {
        var raw = window.localStorage && localStorage.getItem(STORAGE_KEY);
        if (!raw) return;
        var p = JSON.parse(raw);
        if (p.tipoOperacion) vm.tipoOperacion = p.tipoOperacion;
        if (p.categoria) vm.categoria = p.categoria;
        if (typeof p.gasoleoProf === 'boolean') vm.gasoleoProf = p.gasoleoProf;
        if (typeof p.consumoL100 === 'number') vm.consumoL100 = p.consumoL100;
        if (typeof p.costeKmEmpresa === 'number') vm.costeKmEmpresa = p.costeKmEmpresa;
        if (typeof p.esContinuado === 'boolean') vm.esContinuado = p.esContinuado;
        if (typeof p.calcularCosteKm === 'boolean') vm.calcularCosteKm = p.calcularCosteKm;
        if (p.emisor && typeof p.emisor === 'object') {
          vm.emisor.razonSocial = p.emisor.razonSocial || '';
          vm.emisor.nif = p.emisor.nif || '';
          vm.emisor.direccion = p.emisor.direccion || '';
          // Si el usuario ya configuró un emisor en una sesión previa,
          // damos por hecho que querrá seguir usándolo y desplegamos la sección.
          if (vm.emisor.razonSocial || vm.emisor.nif) vm.rellenarJustificante = true;
        }
      } catch (e) { /* perfil corrupto: ignorar */ }
    }

    function borrarPerfil() {
      if (!window.confirm('¿Borrar los datos guardados (preset, consumo, coste por km y datos de emisor)? Esta acción no se puede deshacer.')) return;
      try {
        if (window.localStorage) localStorage.removeItem(STORAGE_KEY);
      } catch (e) { /* nada que hacer */ }
      vm.tipoOperacion = 'urbano';
      vm.categoria = PRESETS.urbano.categoria;
      vm.gasoleoProf = PRESETS.urbano.gasoleoProf;
      vm.consumoL100 = 35;
      vm.costeKmEmpresa = null;
      vm.emisor = { razonSocial: '', nif: '', direccion: '' };
      vm.cliente = { razonSocial: '', nif: '' };
      vm.rellenarJustificante = false;
      recalcular();
    }

    function guardarPerfil() {
      try {
        if (!window.localStorage) return;
        var perfil = {
          tipoOperacion: vm.tipoOperacion,
          categoria: vm.categoria,
          gasoleoProf: vm.gasoleoProf,
          consumoL100: vm.consumoL100,
          costeKmEmpresa: vm.costeKmEmpresa,
          esContinuado: vm.esContinuado,
          calcularCosteKm: vm.calcularCosteKm,
          emisor: vm.emisor
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(perfil));
      } catch (e) { /* quota / modo privado: ignorar */ }
    }

    function onPerfilCambio() {
      recalcular();
      guardarPerfil();
    }

    function anadirFactura() {
      if (vm.facturas.length < 10) {
        vm.facturas.push({ ref: '', importe: null });
      }
    }

    function eliminarFactura(idx) {
      if (vm.facturas.length > 1) {
        vm.facturas.splice(idx, 1);
        recalcular();
      }
    }

    function imprimir() {
      if (!vm.resultado || vm.resultado.error) return;
      vm.generandoPdf = true;
      cargarPdfMake().then(function () {
        var docDef = construirPdfDef();
        pdfMake.createPdf(docDef).download('indexacion-combustible-' + nombreArchivoPdf() + '.pdf');
      }, function () {
        alert('No se ha podido cargar la librería de PDF. Comprueba tu conexión.');
      })['finally'](function () {
        // Pequeño delay para que el usuario vea "Generando…" aunque la red sea instantánea.
        $timeout(function () { vm.generandoPdf = false; }, 200);
      });
    }

    // Carga perezosa de pdfmake + vfs_fonts. Inserta los <script> al primer
    // uso y resuelve cuando window.pdfMake está disponible. ~750 kB diferidos.
    var pdfMakePromise = null;
    function cargarPdfMake() {
      if (typeof pdfMake !== 'undefined') return Promise.resolve();
      if (pdfMakePromise) return pdfMakePromise;
      pdfMakePromise = new Promise(function (resolve, reject) {
        var base = 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.10/';
        loadScript(base + 'pdfmake.min.js').then(function () {
          return loadScript(base + 'vfs_fonts.js');
        }).then(resolve, reject);
      });
      return pdfMakePromise;
    }

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = src;
        s.async = false;
        s.onload = resolve;
        s.onerror = function () { reject(new Error('No se pudo cargar ' + src)); };
        document.head.appendChild(s);
      });
    }

    function copiarConcepto() {
      if (!vm.resultado || vm.resultado.error) return;
      var r = vm.resultado;
      var partes = [
        'Indexación combustible RD-ley 9/2026',
        'Periodo ' + fmtFecha(vm.fechaFirma) + '–' + fmtFecha(vm.fechaEjecucion),
        'G = ' + (r.G > 0 ? '+' : '') + fmtNum(r.G, 2) + ' %',
        'C = ' + fmtNum(r.C, 1),
        'Ajuste ' + (r.deltaPTotal > 0 ? '+' : '') + fmtEur(r.deltaPTotal)
      ];
      var texto = partes.join(' · ');

      var ok = function () {
        vm.copiado = true;
        $timeout(function () { vm.copiado = false; }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(texto).then(ok, function () { fallbackCopy(texto); ok(); });
      } else {
        fallbackCopy(texto);
        ok();
      }
    }

    function fallbackCopy(texto) {
      var ta = document.createElement('textarea');
      ta.value = texto;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) { /* nada que hacer */ }
      document.body.removeChild(ta);
    }

    function descargarCSV() {
      if (!vm.resultado || vm.resultado.error) return;
      var r = vm.resultado;
      // CSV con BOM UTF-8 y separador ';' para que Excel ES lo abra bien.
      var lineas = ['referencia;importe;deltaP;deltaPct;total'];
      for (var i = 0; i < r.facturas.length; i++) {
        var f = r.facturas[i];
        lineas.push(csvEscape(f.ref) + ';' + csvNum(f.importe) + ';' + csvNum(f.deltaP) + ';' + csvNum(f.deltaPct) + ';' + csvNum(f.total));
      }
      lineas.push('TOTAL (' + r.facturas.length + ');' + csvNum(r.importeOriginalTotal) + ';' + csvNum(r.deltaPTotal) + ';' + csvNum(r.deltaPctTotal) + ';' + csvNum(r.importeFinalTotal));
      var blob = new Blob(['﻿' + lineas.join('\r\n')], { type: 'text/csv;charset=utf-8' });
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = 'indexacion-combustible-' + nombreArchivoPdf() + '.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
    }

    function csvEscape(s) {
      s = s == null ? '' : String(s);
      if (s.indexOf(';') !== -1 || s.indexOf('"') !== -1 || s.indexOf('\n') !== -1) {
        s = '"' + s.replace(/"/g, '""') + '"';
      }
      return s;
    }

    function csvNum(n) {
      // Coma decimal para Excel ES.
      return n == null || !isFinite(n) ? '' : n.toFixed(2).replace('.', ',');
    }

    var LABEL_TIPO = {
      urbano: 'Reparto última milla',
      rigido: 'Rígido medio',
      tractora: 'Tractora / linehaul',
      custom: 'Personalizado'
    };
    var LABEL_CATEGORIA = {
      mayor20: 'MMA ≥ 20.000 kg',
      entre: 'MMA 3.500–20.000 kg',
      obras: 'Obras MMA > 3.500 kg',
      ligero: 'MMA ≤ 3.500 kg'
    };

    function zfill(n) { return n < 10 ? '0' + n : '' + n; }

    function fmtFecha(d) {
      if (!d) return '—';
      if (typeof d === 'string') d = new Date(d);
      return zfill(d.getDate()) + '/' + zfill(d.getMonth() + 1) + '/' + d.getFullYear();
    }

    function fmtNum(n, dec) {
      if (n == null || !isFinite(n)) return '—';
      return n.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    }

    function fmtEur(n)  { return fmtNum(n, 2) + ' €'; }
    function fmtPct(n)  { return fmtNum(n, 2) + ' %'; }
    function fmtSign(n) { return (n > 0 ? '+' : '') + fmtEur(n); }
    function colorSigno(n) { return n > 0 ? '#047857' : (n < 0 ? '#b91c1c' : null); }

    function nombreArchivoPdf() {
      if (vm.fechaEjecucion) {
        var d = vm.fechaEjecucion;
        return d.getFullYear() + '-' + zfill(d.getMonth() + 1) + '-' + zfill(d.getDate());
      }
      return 'sin-fecha';
    }

    function tablaDatos(filas) {
      return {
        table: {
          widths: ['auto', '*'],
          body: filas.map(function (r) {
            return [
              { text: r[0], color: '#52606d', fontSize: 9 },
              { text: r[1], fontSize: 10, bold: true }
            ];
          })
        },
        layout: 'noBorders'
      };
    }

    function kpi(label, value, color) {
      return {
        width: '*',
        table: {
          widths: ['*'],
          body: [[{
            stack: [
              { text: label.toUpperCase(), fontSize: 7, color: '#52606d', characterSpacing: 0.5 },
              { text: value, fontSize: 14, bold: true, color: color || '#1f2933', margin: [0, 3, 0, 0] }
            ],
            fillColor: '#f5f7fa',
            border: [false, false, false, false],
            margin: [10, 10, 10, 10]
          }]]
        },
        layout: 'noBorders'
      };
    }

    function partesContent() {
      // Bloque de cabecera con emisor/cliente, solo si la sección está
      // desplegada y el usuario ha rellenado al menos un campo.
      if (!vm.rellenarJustificante) return null;
      var emisorLineas = lineasEntidad(vm.emisor);
      var clienteLineas = lineasEntidad(vm.cliente);
      if (!emisorLineas.length && !clienteLineas.length) return null;

      var emisorStack = [{ text: 'EMISOR (TRANSPORTISTA)', fontSize: 8, bold: true, color: '#52606d', characterSpacing: 0.5, margin: [0, 0, 0, 4] }];
      if (emisorLineas.length) {
        emisorStack = emisorStack.concat(emisorLineas.map(function (l) { return { text: l, fontSize: 9 }; }));
      } else {
        emisorStack.push({ text: '—', fontSize: 9, color: '#9aa5b1' });
      }

      var clienteStack = [{ text: 'CLIENTE / DESTINATARIO', fontSize: 8, bold: true, color: '#52606d', characterSpacing: 0.5, margin: [0, 0, 0, 4] }];
      if (clienteLineas.length) {
        clienteStack = clienteStack.concat(clienteLineas.map(function (l) { return { text: l, fontSize: 9 }; }));
      } else {
        clienteStack.push({ text: '—', fontSize: 9, color: '#9aa5b1' });
      }

      return {
        columns: [
          { width: '*', stack: emisorStack },
          { width: '*', stack: clienteStack }
        ],
        columnGap: 20,
        margin: [0, 0, 0, 14]
      };
    }

    function lineasEntidad(e) {
      if (!e) return [];
      var lineas = [];
      if (e.razonSocial) lineas.push(e.razonSocial);
      if (e.nif)         lineas.push('NIF: ' + e.nif);
      if (e.direccion)   lineas.push(e.direccion);
      return lineas;
    }

    function construirPdfDef() {
      var r = vm.resultado;
      var content = [];

      content.push({ text: 'Cálculo de indexación de combustible', fontSize: 16, bold: true });
      content.push({
        text: 'RD-ley 9/2026 · Tramo 3 (transportes ejecutados desde el 15/04/2026)',
        fontSize: 9, color: '#52606d', margin: [0, 2, 0, 14]
      });

      var partes = partesContent();
      if (partes) content.push(partes);

      // Bloque de datos en dos columnas: vehículo + contrato.
      content.push({
        columns: [
          {
            width: '*',
            stack: [
              { text: 'OPERACIÓN Y VEHÍCULO', fontSize: 9, bold: true, color: '#52606d', characterSpacing: 0.5, margin: [0, 0, 0, 6] },
              tablaDatos([
                ['Tipo de operación', LABEL_TIPO[vm.tipoOperacion] || vm.tipoOperacion],
                ['Categoría', LABEL_CATEGORIA[vm.categoria] || vm.categoria],
                ['Gasóleo profesional', vm.gasoleoProf ? 'Sí (≥ 7,5 t IH-GP)' : 'No (< 7,5 t)']
              ])
            ]
          },
          {
            width: '*',
            stack: [
              { text: 'DATOS DEL CONTRATO', fontSize: 9, bold: true, color: '#52606d', characterSpacing: 0.5, margin: [0, 0, 0, 6] },
              tablaDatos([
                ['Fecha firma contrato/tarifa', fmtFecha(vm.fechaFirma)],
                ['Fecha ejecución', fmtFecha(vm.fechaEjecucion)],
                ['Precio firma', fmtNum(vm.precioFirma, 3) + ' €/l'],
                ['Precio ejecución', fmtNum(vm.precioEjecucion, 3) + ' €/l']
              ])
            ]
          }
        ],
        columnGap: 20,
        margin: [0, 0, 0, 16]
      });

      // KPIs
      content.push({
        columns: [
          kpi('Variación G', fmtPct(r.G), r.G < 0 ? '#b91c1c' : null),
          kpi('PAI día ejecución', fmtNum(r.PAI, 3) + ' €/l'),
          kpi('Coeficiente C', fmtNum(r.C, 1)),
          kpi('Ajuste sobre factura', (r.deltaPctTotal > 0 ? '+' : '') + fmtPct(r.deltaPctTotal), r.deltaPctTotal < 0 ? '#b91c1c' : null)
        ],
        columnGap: 8,
        margin: [0, 0, 0, 12]
      });

      // Aviso revisión
      content.push({
        table: {
          widths: ['*'],
          body: [[{
            stack: [
              { text: r.aplicaRevision ? 'Revisión obligatoria automática' : 'No alcanza el umbral del 5 %', bold: true, fontSize: 10 },
              { text: r.umbralExplicacion, fontSize: 9, margin: [0, 3, 0, 0] }
            ],
            fillColor: r.aplicaRevision ? '#d1fae5' : '#fef3c7',
            color: r.aplicaRevision ? '#047857' : '#92400e',
            border: [false, false, false, false],
            margin: [12, 10, 12, 10]
          }]]
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 14]
      });

      content.push({ text: 'DESGLOSE POR FACTURA', fontSize: 9, bold: true, color: '#52606d', characterSpacing: 0.5, margin: [0, 0, 0, 6] });
      var rows = [[
        { text: 'Referencia', bold: true, fontSize: 9, color: '#52606d' },
        { text: 'Importe original', bold: true, fontSize: 9, color: '#52606d', alignment: 'right' },
        { text: 'Ajuste ΔP', bold: true, fontSize: 9, color: '#52606d', alignment: 'right' },
        { text: 'Total', bold: true, fontSize: 9, color: '#52606d', alignment: 'right' }
      ]];
      // Celda ΔP con € + (%) en línea: el € en color de signo y peso normal,
      // el % en color heredado pero algo más pequeño y suave para no competir.
      function celdaDelta(deltaP, deltaPct, bold) {
        return {
          text: [
            { text: fmtSign(deltaP), bold: !!bold },
            { text: '  (' + (deltaPct > 0 ? '+' : '') + fmtPct(deltaPct) + ')', fontSize: 8 }
          ],
          alignment: 'right',
          color: colorSigno(deltaP)
        };
      }

      for (var i = 0; i < r.facturas.length; i++) {
        var f = r.facturas[i];
        rows.push([
          f.ref,
          { text: fmtEur(f.importe), alignment: 'right' },
          celdaDelta(f.deltaP, f.deltaPct, false),
          { text: fmtEur(f.total), alignment: 'right', bold: true }
        ]);
      }
      rows.push([
        { text: 'TOTAL (' + r.facturas.length + (r.facturas.length === 1 ? ' factura)' : ' facturas)'), bold: true },
        { text: fmtEur(r.importeOriginalTotal), alignment: 'right', bold: true },
        celdaDelta(r.deltaPTotal, r.deltaPctTotal, true),
        { text: fmtEur(r.importeFinalTotal), alignment: 'right', bold: true }
      ]);
      content.push({
        table: { widths: ['*', 'auto', 'auto', 'auto'], body: rows, headerRows: 1 },
        layout: 'lightHorizontalLines',
        margin: [0, 0, 0, 14]
      });

      if (r.costeKm) {
        var k = r.costeKm;
        content.push({ text: 'COSTE POR KM', fontSize: 9, bold: true, color: '#52606d', characterSpacing: 0.5, margin: [0, 0, 0, 6] });
        var bodyKm = [
          ['Incremento por litro', { text: fmtNum(k.incLitro, 3) + ' €/l', alignment: 'right' }],
          ['Incremento por 100 km', { text: fmtEur(k.inc100km), alignment: 'right' }],
          ['Incremento por km', { text: fmtNum(k.incKm, 4) + ' €/km', alignment: 'right' }],
          ['Incremento total del viaje (' + fmtNum(k.km, 0) + ' km)', { text: fmtEur(k.incViaje), alignment: 'right' }]
        ];
        if (k.costeKmEmpresa != null) {
          bodyKm.push(['Importe sin incremento', { text: fmtEur(k.importeSin), alignment: 'right' }]);
          bodyKm.push(['Importe con incremento de gasóleo', { text: fmtEur(k.importeCon), alignment: 'right' }]);
          bodyKm.push([{ text: 'Nuevo coste por km', bold: true }, { text: fmtNum(k.nuevoCosteKm, 4) + ' €/km', alignment: 'right', bold: true }]);
        }
        content.push({
          table: { widths: ['*', 'auto'], body: bodyKm },
          layout: 'lightHorizontalLines',
          margin: [0, 0, 0, 14]
        });
      }

      content.push({
        text: 'El ajuste debe figurar desglosado en la factura (art. 38 Ley 15/2009, modificado por RD-ley 9/2026). En contratos continuados, la revisión se aplica además en cada periodo de facturación, sin umbral.',
        fontSize: 8, color: '#52606d', italics: true, margin: [0, 4, 0, 0]
      });

      var ahora = new Date();
      return {
        pageSize: 'A4',
        pageMargins: [40, 40, 40, 50],
        defaultStyle: { fontSize: 10, color: '#1f2933' },
        content: content,
        footer: function (currentPage, pageCount) {
          return {
            text: 'Generado el ' + fmtFecha(ahora) + ' · Calculadora orientativa basada en RD-ley 9/2026 · ' + currentPage + '/' + pageCount+'\nMENSATRANS - Software online de gestión y facturación para empresas de transporte urgente y mensajerías\nwww.mensatrans.com',
            alignment: 'center', fontSize: 8, color: '#52606d', margin: [40, 0]
          };
        }
      };
    }

    // Con ambas fechas pre-rellenadas, disparamos la consulta inicial al MITMS
    // para que el usuario vea los precios sin tener que tocar nada.
    asegurarToken().then(cargarPrecios);

    // Token firmado HMAC emitido por /api/sesion. TTL ~1h. Lo refrescamos si
    // el servidor responde 401 (expiró) o si nos faltan más de unos segundos.
    var apiToken = null;
    var apiTokenExp = 0;

    function asegurarToken() {
      // Devolvemos $q.when (no Promise.resolve nativo): si la cadena se mezcla con
      // promesas nativas, las resoluciones del $http posterior caen fuera del
      // $digest de Angular y la UI no refleja vm.precioFirma/precioEjecucion
      // hasta el siguiente evento del usuario.
      if (apiToken && apiTokenExp - Date.now() > 60_000) return $q.when();
      return $http.get('/api/sesion').then(function (resp) {
        apiToken = resp.data && resp.data.token;
        apiTokenExp = (resp.data && resp.data.exp) || 0;
      });
    }

    function onFechaCambio() {
      recalcular();
      cargarPrecios();
    }

    // Marca si el usuario ha tocado manualmente la firma. Mientras no la haya
    // tocado, la firma se re-ancla al 1 de enero del año de la ejecución cada
    // vez que ésta cambia (caso enero: ejec dic año previo → firma 1/1 año previo).
    var firmaTocadaManualmente = false;

    function onFechaFirmaCambio() {
      firmaTocadaManualmente = true;
      onFechaCambio();
    }

    function onFechaEjecucionCambio() {
      if (!firmaTocadaManualmente && vm.fechaEjecucion) {
        var anyo = (vm.fechaEjecucion instanceof Date)
          ? vm.fechaEjecucion.getFullYear()
          : new Date(vm.fechaEjecucion).getFullYear();
        var nueva = new Date(anyo, 0, 1);
        // Solo actualizamos si el año cambia, para no provocar loops innecesarios.
        if (!vm.fechaFirma || (vm.fechaFirma instanceof Date && vm.fechaFirma.getFullYear() !== anyo)) {
          vm.fechaFirma = nueva;
        }
      }
      onFechaCambio();
    }

    function aplicarPreset() {
      var preset = PRESETS[vm.tipoOperacion];
      if (preset) {
        vm.categoria = preset.categoria;
        vm.gasoleoProf = preset.gasoleoProf;
      }
      recalcular();
      guardarPerfil();
    }

    function onEdicionManual() {
      // Si el usuario cambia categoría/gasoleoProf y ya no encajan con el preset
      // activo, marcamos el preset como 'custom' para no mentir en la UI.
      var preset = PRESETS[vm.tipoOperacion];
      if (preset && (preset.categoria !== vm.categoria || preset.gasoleoProf !== vm.gasoleoProf)) {
        vm.tipoOperacion = 'custom';
      }
      recalcular();
      guardarPerfil();
    }

    function cargarPrecios() {
      vm.errorPrecios = null;
      vm.avisoPrecios = null;
      vm.semanasUsadas = null;

      // Sin ambas fechas o con orden inválido no se intenta el fetch:
      // el usuario aún está rellenando, no es un error que reportar.
      if (!vm.fechaFirma || !vm.fechaEjecucion) return;
      if (vm.fechaFirma > vm.fechaEjecucion) return;

      var lunFirma = lunesPublicacion(vm.fechaFirma);
      var lunEjec = lunesPublicacion(vm.fechaEjecucion);

      // Cache hit completo (ambas semanas conocidas): no llamamos al endpoint.
      if (cacheSemanas[lunFirma] != null && cacheSemanas[lunEjec] != null) {
        vm.precioFirma = cacheSemanas[lunFirma];
        vm.precioEjecucion = cacheSemanas[lunEjec];
        vm.avisoPrecios = true;
        vm.semanasUsadas = { firma: lunFirma, ejecucion: lunEjec };
        recalcular();
        return;
      }

      vm.cargandoPrecios = true;
      hacerPeticionPrecios(false).then(function (resp) {
        var data = resp.data || {};
        var precios = data.precios || [];
        if (!precios.length) {
          vm.errorPrecios = true;
          return;
        }
        // Cachear todas las semanas devueltas (incluidas intermedias).
        for (var i = 0; i < precios.length; i++) {
          var p = precios[i];
          if (p && p.fecha && p.precio != null) {
            cacheSemanas[p.fecha.slice(0, 10)] = p.precio;
          }
        }
        vm.precioFirma = precios[0].precio;
        vm.precioEjecucion = precios[precios.length - 1].precio;
        vm.semanasUsadas = { firma: lunFirma, ejecucion: lunEjec };
        vm.avisoPrecios = true;
        recalcular();
      }, function () {
        vm.errorPrecios = true;
      })['finally'](function () {
        vm.cargandoPrecios = false;
      });
    }

    // Hace la petición real a /api/combustible. Si responde 401 (token caducado
    // entre el page load y este momento) refresca el token y reintenta UNA vez.
    function hacerPeticionPrecios(reintentado) {
      return pedirPrecios({
        firma: toISODay(vm.fechaFirma),
        ejecucion: toISODay(vm.fechaEjecucion),
        inferiorMMA: !vm.gasoleoProf,
      }, reintentado);
    }

    function pedirPrecios(params, reintentado) {
      return asegurarToken().then(function () {
        return $http({
          method: 'GET',
          url: '/api/combustible',
          params: params,
          headers: { 'X-Api-Token': apiToken },
        });
      }).catch(function (err) {
        if (!reintentado && err && err.status === 401) {
          apiToken = null;
          apiTokenExp = 0;
          return pedirPrecios(params, true);
        }
        throw err;
      });
    }

    // Tools WebMCP (navigator.modelContext) — versión single-week para que un
    // agente pida un precio puntual sin tocar vm.fechaFirma/vm.fechaEjecucion.
    function pedirPrecioSemana(lunesISO, gasoleoProf) {
      return pedirPrecios({
        firma: lunesISO,
        ejecucion: lunesISO,
        inferiorMMA: !gasoleoProf,
      }, false).then(function (resp) {
        var precios = (resp.data && resp.data.precios) || [];
        if (!precios.length) return null;
        // Aprovechamos para cachear: si el usuario coincide con esa semana,
        // ya no se vuelve a pedir.
        for (var i = 0; i < precios.length; i++) {
          var p = precios[i];
          if (p && p.fecha && p.precio != null) {
            cacheSemanas[p.fecha.slice(0, 10)] = p.precio;
          }
        }
        return precios[0].precio;
      });
    }

    // Garantiza que cualquier mutación de vm hecha por una tool WebMCP entre
    // dentro de un ciclo $digest. Sin esto, el agente cambia vm.fechaFirma y
    // la UI no refresca hasta el siguiente evento de teclado/click del user.
    function aplicarMutacion(fn) {
      $timeout(fn);
    }

    function recalcular() {
      var pf = parseFloat(vm.precioFirma);
      var pe = parseFloat(vm.precioEjecucion);

      if (!isFinite(pf) || pf <= 0 || !isFinite(pe) || pe <= 0) {
        vm.resultado = null;
        vm.faltaImporte = false;
        return;
      }

      if (vm.fechaFirma && vm.fechaEjecucion && vm.fechaFirma > vm.fechaEjecucion) {
        vm.resultado = { error: 'La fecha de ejecución no puede ser anterior a la firma del contrato.' };
        vm.faltaImporte = false;
        return;
      }

      if (vm.fechaEjecucion && vm.fechaEjecucion < FECHA_TRAMO_3) {
        vm.resultado = {
          error: 'Esta calculadora aplica el Tramo 3 (RD-ley 9/2026), válido para transportes ejecutados desde el 15/04/2026. Para fechas anteriores debe aplicarse la fórmula vigente entonces.'
        };
        vm.faltaImporte = false;
        return;
      }

      var calc = calcularBase({
        precioFirma: pf,
        precioEjecucion: pe,
        fechaEjecucion: vm.fechaEjecucion,
        categoria: vm.categoria,
        gasoleoProf: vm.gasoleoProf
      });
      var G_pct = calc.G_pct;
      var PAI = calc.PAI;
      var C = calc.C;
      var aplicaRevision = vm.esContinuado || Math.abs(G_pct) >= UMBRAL_AUTOMATICO_PCT;

      // % de ΔP sobre el importe de la factura. Es invariante a P:
      // ΔP = G·P·C/100  ⇒  (ΔP/P)·100 = G·C  (con G ya en porcentaje).
      var deltaPct = G_pct * C;
      var rows = [];
      var totalImp = 0, totalDelta = 0;
      for (var i = 0; i < vm.facturas.length; i++) {
        var imp = parseFloat(vm.facturas[i].importe);
        if (!isFinite(imp) || imp <= 0) continue;
        var deltaP = calcularDeltaP(G_pct, imp, C);
        rows.push({
          ref: vm.facturas[i].ref || ('Factura ' + (i + 1)),
          importe: imp,
          deltaP: deltaP,
          deltaPct: deltaPct,
          total: imp + deltaP
        });
        totalImp += imp;
        totalDelta += deltaP;
      }
      // Precios y fechas válidos pero sin importes: estado intermedio que
      // muestra un aviso explícito en lugar de no enseñar nada (lo que hacía
      // pensar al usuario que la calculadora no había recogido sus datos).
      if (rows.length === 0) {
        vm.resultado = null;
        vm.faltaImporte = true;
        return;
      }
      vm.faltaImporte = false;

      var base = {
        G: G_pct,
        PAI: PAI,
        C: C,
        aplicaRevision: aplicaRevision,
        umbralExplicacion: construirExplicacion(G_pct, vm.esContinuado),
        facturas: rows,
        importeOriginalTotal: totalImp,
        deltaPTotal: totalDelta,
        deltaPctTotal: deltaPct,
        importeFinalTotal: totalImp + totalDelta
      };

      // Bloque de coste por km (opcional). Fórmulas según sección 8.4.7
      // del documento de conocimiento (calculadora completa CETM).
      if (vm.calcularCosteKm) {
        var consumo = parseFloat(vm.consumoL100);
        var km = parseFloat(vm.kilometros);
        var costeKmEmp = parseFloat(vm.costeKmEmpresa);
        if (isFinite(consumo) && consumo > 0 && isFinite(km) && km > 0) {
          var incLitro = pe - pf;
          var inc100km = consumo * incLitro;
          var incKm = (consumo / 100) * incLitro;
          var incViaje = (km * consumo / 100) * incLitro;
          var bloqueKm = {
            consumo: consumo,
            km: km,
            incLitro: incLitro,
            inc100km: inc100km,
            incKm: incKm,
            incViaje: incViaje
          };
          if (isFinite(costeKmEmp) && costeKmEmp > 0) {
            bloqueKm.costeKmEmpresa = costeKmEmp;
            bloqueKm.importeSin = costeKmEmp * km;
            bloqueKm.importeCon = bloqueKm.importeSin + incViaje;
            bloqueKm.nuevoCosteKm = costeKmEmp + incKm;
          }
          base.costeKm = bloqueKm;
        }
      }

      vm.resultado = base;
    }

    function construirExplicacion(G_pct, continuado) {
      var abs = Math.abs(G_pct).toFixed(2);
      if (continuado) {
        return 'Contrato continuado: la revisión se aplica de forma automática en cada periodo de facturación, sin umbral. Variación detectada: ' + abs + ' %.';
      }
      if (Math.abs(G_pct) >= UMBRAL_AUTOMATICO_PCT) {
        return 'Variación absoluta de ' + abs + ' %, igual o superior al 5 % legal: la revisión es obligatoria y automática (art. 38.2 Ley 15/2009).';
      }
      return 'Variación absoluta de ' + abs + ' %, inferior al 5 %. Solo procede revisar si las partes pactaron por escrito un umbral menor antes de firmar el contrato.';
    }

    // Capa fina WebMCP: feature-detect + registro de tools. No-op en navegadores
    // sin navigator.modelContext (Firefox, Safari, Chrome estable). Ver mcp.ts.
    registrarMcp({
      vm: vm,
      aplicarMutacion: aplicarMutacion,
      pedirPrecioSemana: pedirPrecioSemana,
      cargarPrecios: cargarPrecios,
      recalcular: recalcular,
      aplicarPreset: aplicarPreset,
    });
  }

  // Bootstrap manual: el bundler de Bun marca este script como `type="module"`,
  // que es diferido y corre después de DOMContentLoaded — el auto-bootstrap de
  // AngularJS (que escucha DOMContentLoaded) no llegaría a ver el módulo.
  angular.bootstrap(document, ['indexacionApp']);
})();
